import axios from 'axios';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { getToken } from '../../../../../Contexts/InitProvider';
import { useTemplate } from '../../../../../features/template/TemplateProvider';
import { getApiUrl } from '../../../../../utils/Env';
import {
    CameraIcon,
    ImageUploadingIcon,
    LinkArrow,
    ProductIcon,
    ReloadGrIcon
} from '../../../../../utils/SVGIcon';
import { useProductDt } from '../ProductDetailsProvider';

function ButtonWrapper({ children, className, onClick }) {
    return (
        <button
            type="button"
            className={`h-[34px] text-sm font-e text-secondary bg-[rgba(255,255,255,0.80)] backdrop-blur-[2px] rounded-5 ${className}`}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

function ProductDetails({ productInfo }) {
    const { id, logoUrl } = productInfo;
    const { setMessage } = useTemplate();
    const { handleReload } = useProductDt();
    const [isLoading, setIsLoading] = useState(false);
    const handleUpload = (e) => {
        setIsLoading(true);
        if (!e.target.files[0]) return;
        const formData = new FormData();
        formData.append('profileImage', e.target.files[0]);
        axios
            .put(`${getApiUrl()}/api/application/${id}/change-logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: getToken()
                }
            })
            .then(({ data }) => {
                if (data?.status === 0) {
                    setMessage({ type: 'success', text: data?.title });
                    setIsLoading(false);
                    handleReload();
                } else {
                    setMessage({ type: 'error', text: data?.title });
                    setIsLoading(false);
                }
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.toString(0) });
                setIsLoading(false);
            });
    };

    const isProductInactive = productInfo?.status === 'inactive';

    return (
        <div
            className={`flex flex-row gap-4 items-center  ${
                productInfo?.demo ? 'placeholder-mode' : ''
            }`}
        >
            <div className="size-[100px] bg-[#E6F6ED] relative rounded-full p-4">
                <span className="w-full block">
                    {isLoading ? (
                        <ImageUploadingIcon />
                    ) : (
                        <span className="w-full block">
                            {logoUrl ? (
                                <img src={logoUrl} alt="" className="w-full block" />
                            ) : (
                                <ProductIcon />
                            )}
                        </span>
                    )}
                </span>
                <label
                    type="button"
                    className={`absolute bottom-0 right-0 size-[31px] p-[7px] text-primary bg-white rounded-full cursor-pointer ${
                        isProductInactive ? 'invisible' : ''
                    }`}
                >
                    <input
                        type="file"
                        className="hidden"
                        onChange={handleUpload}
                        accept="image/png, image/jpeg, image/jpg"
                    />
                    <CameraIcon />
                </label>
            </div>
            <div className="flex flex-col ite gap-1">
                <div className="flex flex-row items-center gap-3">
                    <span className="relative text-primary text-2xl font-medium whitespace-nowrap  text-ellipsis">
                        {productInfo?.applicationTitle || '----'}
                        <Link
                            to={productInfo?.website}
                            target="_blank"
                            className="absolute top-0 -right-6 transition-all duration-300 ease-in-out w-4"
                        >
                            <span>
                                <LinkArrow className="text-black hover:text-white" />
                            </span>
                        </Link>
                    </span>
                </div>
                <p className="text-sm text-primary">
                    <span>{productInfo?.description || '-------------'}</span>
                </p>
            </div>
        </div>
    );
}

function ProductInfo() {
    const { openModal, productInfo, handleReload } = useProductDt();

    return (
        <div className="flex items-center relative w-full h-[160px] mb-4 product-bg">
            <div className="w-full h-full flex items-center p-7.5 z-10">
                <ProductDetails productInfo={productInfo} />
            </div>

            <div className="flex items-center gap-x-2.5 absolute top-2.5 right-2.5 z-20">
                <ButtonWrapper className="w-[34px] p-1" onClick={handleReload}>
                    <ReloadGrIcon />
                </ButtonWrapper>
                <ButtonWrapper
                    className="w-[100px] px-2.5 py-2"
                    onClick={() => openModal('editProduct', productInfo)}
                >
                    Edit Product
                </ButtonWrapper>
            </div>
        </div>
    );
}

export default ProductInfo;
